import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/*
 * Both callers await this and decide what to say themselves — the overview's "Check
 * status" button reports it, the Integrated Browser return polls it and only speaks up
 * once the polling gives up. So the global mutation handler is opted out of: its
 * "An error occurred" would fire on every poll attempt.
 */
export const useCheckReferralStatus = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async (referralId) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/referrals/${referralId}/check-status`
      );
      return response.data;
    },
  });
};
